import React, { Component, Suspense, lazy, useState, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Spinner from '../app/shared/Spinner';

import UserKyc from './components/userManagement/UserKyc';
import ViewKyc from './components/userManagement/ViewKyc';
import Transactionhistory from './components/transaction/Transactionhistory';
import Bonushistory from './components/transaction/Bonushistory';
import PenaltyHistory from './components/transaction/PenaltyHistory';
import Withdrawlhistory from './components/transaction/Withdrawlhistory';
import Deposits from './components/transaction/Deposits';
import Pages from './components/Settings/Page';

import axios from "axios"
import Earings from './dashboard/Earings';
import ComKyc from './components/userManagement/ComKyc';
import SucWithdraw from './components/transaction/SucWithdraw';
import RejectKyc from './components/userManagement/RejectKyc';
import Completed from './components/challengeManagement/Completed';
import Conflict from './components/challengeManagement/Conflict';
import Cancelled from './components/challengeManagement/Cancelled';
import CancelRequests from './components/challengeManagement/CancelRequests';
import ResultPending from './components/challengeManagement/ResultPending';
import Running from './components/challengeManagement/Running';
import Drop from './components/challengeManagement/Drop';
import New from './components/challengeManagement/New';
import PendingChallenge from './components/PendingChallenge'; // Imported already
import View from './components/userManagement/View';
import UpdatePassword from './components/adminManagement/UpdatePassword';
import Profile from './components/adminManagement/Profile';
import Permissions from './components/agentManagement/Permissions';

import DepositReport from './components/Reports/DepositReport';
import BonusReport from './components/Reports/BonusReport';
import WithdrawalReport from './components/Reports/WithdrawalReport';
import PenaltyReport from './components/Reports/PenaltyReport';
import { Sitesettings } from './components/adminManagement/Sitesettings';

// Lazy imports
const Alladmin = lazy(() => import('./components/adminManagement/Alladmin'));
const Addadmin = lazy(() => import('./components/adminManagement/Addadmin'));
const Allgames = lazy(() => import('./components/gameManagement/Allgames'));
const Addgame = lazy(() => import('./components/gameManagement/Addgame'));
const Allusers = lazy(() => import('./components/userManagement/Allusers'));
const Adduser = lazy(() => import('./components/userManagement/Adduser'));
const Allagents = lazy(() => import('./components/agentManagement/Allagent'));
const Addagent = lazy(() => import('./components/agentManagement/Addagent'));
const Allchallenges = lazy(() => import('./components/challengeManagement/Allchallenge'));
const Views = lazy(() => import('./components/challengeManagement/Views'));
const Alldeposits = lazy(() => import('./components/transaction/Deposits'));
const Allwithdrawl = lazy(() => import('./components/transaction/Withdrawl'));
const Penaltybonus = lazy(() => import('./components/transaction/Penalty&bonus'));
const ManualDeposit = lazy(() => import('./components/transaction/ManualDeposit'));
const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const RealProfit = lazy(() => import('./dashboard/RealProfit'));
const OtpLookup = lazy(() => import('./dashboard/OtpLookup'));
const Buttons = lazy(() => import('./basic-ui/Buttons'));
const Dropdowns = lazy(() => import('./basic-ui/Dropdowns'));
const Typography = lazy(() => import('./basic-ui/Typography'));
const BasicElements = lazy(() => import('./form-elements/BasicElements'));
const BasicTable = lazy(() => import('./tables/BasicTable'));
const Mdi = lazy(() => import('./icons/Mdi'));
const ChartJs = lazy(() => import('./charts/ChartJs'));
const Error404 = lazy(() => import('./error-pages/Error404'));
const Error500 = lazy(() => import('./error-pages/Error500'));
const Login = lazy(() => import('./user-pages/Login'));
const Register1 = lazy(() => import('./user-pages/Register'));

const AppRoutes = () => {
  const access_token = localStorage.getItem("token")
  const [dashboard, setDashboard] = useState(false)
  const [earnings, setEarnings] = useState(false)
  const [allAdmins, setAllAdmins] = useState(false)
  const [newAdmin, setNewAdmin] = useState(false)
  const [sitesettings, setsitesettings] = useState(false)
  const [allUsers, setAllUsers] = useState(false)
  const [newUser, setNewUser] = useState(false)
  const [pendingKyc, setPendingKyc] = useState(false)
  const [completedKyc, setCompletedKyc] = useState(false)
  const [rejectKyc, setRejectKyc] = useState(false)
  
  // Challenge States
  const [allChallenges, setAllChallenges] = useState(false)
  const [pendingChallenges, setPendingChallenges] = useState(false) // Added
  const [completedChallenges, setCompletedChallenges] = useState(false)
  const [conflictChallenges, setConflictChallenges] = useState(false)
  const [cancelledChallenges, setCancelledChallenges] = useState(false)
  const [runningChallenges, setRunningChallenges] = useState(false)
  const [dropChallenges, setDropChallenges] = useState(false)
  const [newChallenge, setNewChallenge] = useState(false)

  const [penaltyBonus, setPenaltyBonus] = useState(false)
  const [manualDeposit, setManualDeposit] = useState(false)
  const [depositHistory, setDepositHistory] = useState(false)
  const [bonusHistory, setBonusHistory] = useState(false)
  const [withdrawlHistory, setWithdrawlHistory] = useState(false)
  const [allWithdrawlRequests, setAllWithdrawlRequests] = useState(false)
  const [allDepositRequests, setAllDepositRequests] = useState(false)
  const [pages, setPages] = useState(false)
  
  const [bonusReport, setBonusReport] = useState(false)
  const [penaltyReport, setpenaltyReport] = useState(false)
  const [withdrawalReport, setwithdrawalReport] = useState(false)
  const [depositReport, setdepositReport] = useState(false)

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  var baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  useEffect(() => {
    if (access_token) {
      axios.get(baseUrl + `me`, {
        headers: { Authorization: `Bearer ${access_token}` }
      }).then(res => {
        if (res.data.user_type === "Admin") {
          setDashboard(true); setEarnings(true); setAllAdmins(true); setNewAdmin(true);
          setAllUsers(true); setsitesettings(true); setNewUser(true); setPendingKyc(true);
          setCompletedKyc(true); setRejectKyc(true); setAllChallenges(true);
          setPendingChallenges(true); // Admin gets access
          setCompletedChallenges(true); setConflictChallenges(true);
          setCancelledChallenges(true); setRunningChallenges(true); setDropChallenges(true);
          setNewChallenge(true); setPenaltyBonus(true); setManualDeposit(true); setDepositHistory(true);
          setBonusHistory(true); setWithdrawlHistory(true); setAllWithdrawlRequests(true);
          setAllDepositRequests(true); setPages(true); setBonusReport(true);
          setpenaltyReport(true); setwithdrawalReport(true); setdepositReport(true);
        }
        if (res.data.user_type === "Agent") {
          const per = res.data.Permissions;
          setDashboard(per[0].Status); setEarnings(per[1].Status); setAllAdmins(per[2].Status);
          setNewAdmin(per[3].Status); setAllUsers(per[4].Status); setNewUser(per[5].Status);
          setPendingKyc(per[6].Status); setCompletedKyc(per[7].Status); setRejectKyc(per[8].Status);
          setAllChallenges(per[9].Status);
          setPendingChallenges(per[9].Status); // Same permission as all challenges
          setCompletedChallenges(per[10].Status); setConflictChallenges(per[11].Status);
          setCancelledChallenges(per[12].Status); setRunningChallenges(per[13].Status);
          setNewChallenge(per[14].Status); setPenaltyBonus(per[15].Status); setManualDeposit(per[15].Status);
          setDepositHistory(per[16].Status); setWithdrawlHistory(per[17].Status);
          setAllWithdrawlRequests(per[18].Status); setAllDepositRequests(per[19].Status);
          setPages(per[20].Status); setBonusHistory(per[21].Status); setBonusReport(per[22].Status);
          setwithdrawalReport(per[23].Status); setdepositReport(per[24].Status);
          setpenaltyReport(per[25].Status); setDropChallenges(per[26].Status);
        }
      }).catch(err => console.log(err))
    }
  }, [access_token, baseUrl])

  if (!access_token) {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path="/adminlogin" component={Login} />
          <Redirect to="/adminlogin" />
        </Switch >
      </Suspense>
    )
  } else {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Redirect exact from="/" to="/dashboard" />
          {dashboard && <Route exact path="/dashboard" component={Dashboard} />}
          {dashboard && <Route exact path="/real-profit" component={RealProfit} />}
          <Route exact path="/otp-lookup" component={OtpLookup} />
          {earnings && <Route exact path="/earinigs" component={Earings} />}

          {/* Admin Routes */}
          {allAdmins && <Route path="/admin/alladmins" component={Alladmin} />}
          {newAdmin && <Route path="/admin/addadmin" component={Addadmin} />}
          {sitesettings && <Route path="/admin/sitesettings" component={Sitesettings} />}
          <Route path="/admin/update" component={UpdatePassword} />
          <Route path="/admin/profile" component={Profile} />
          <Route path="/agent/permissions/:id" component={Permissions} />

          {/* Game Routes */}
          <Route path="/game/allgames" component={Allgames} />
          <Route path="/game/addgame" component={Addgame} />

          {/* User Routes */}
          {allUsers && <Route path="/user/allusers" component={Allusers} />}
          {newUser && <Route path="/user/adduser/:id" component={Adduser} />}
          {newUser && <Route path="/user/adduser" component={Adduser} />}
          {pendingKyc && <Route path="/user/UserKyc" component={UserKyc} />}
          <Route path="/user/view" component={ViewKyc} />
          {completedKyc && <Route path="/user/kyc" component={ComKyc} />}
          {rejectKyc && <Route path="/user/reject" component={RejectKyc} />}
          <Route path="/user/view_user/:id" component={View} />

          {/* Agent Routes */}
          <Route path="/agent/allagents" component={Allagents} />
          <Route path="/agent/addagent" component={Addagent} />

          {/* Challenge Routes */}
          {allChallenges && <Route path="/challenge/allchallenges" component={Allchallenges} />}
          {pendingChallenges && <Route path="/challenge/pending_challange" component={PendingChallenge} />}
          {completedChallenges && <Route path="/challenge/completed_challange" component={Completed} />}
          {conflictChallenges && <Route path="/challenge/conflict_challange" component={Conflict} />}
          {cancelledChallenges && <Route path="/challenge/cancelled_challange" component={Cancelled} />}
          {cancelledChallenges && <Route path="/challenge/cancel_requests" component={CancelRequests} />}
          {cancelledChallenges && <Route path="/challenge/result_pending" component={ResultPending} />}
          {runningChallenges && <Route path="/challenge/running_challange" component={Running} />}
          {dropChallenges && <Route path="/challenge/drop_challange" component={Drop} />}
          {newChallenge && <Route path="/challenge/new_challange" component={New} />}

          {/* Transaction Routes */}
          {allDepositRequests && <Route path="/transaction/alldeposits" component={Alldeposits} />}
          {allWithdrawlRequests && <Route path="/transaction/allwithdrawl" component={Allwithdrawl} />}
          {penaltyBonus && <Route path="/transaction/penaltybonus" component={Penaltybonus} />}
          {manualDeposit && <Route path="/transaction/manualdeposit" component={ManualDeposit} />}
          {depositHistory && <Route path="/transaction/transaction_history" component={Transactionhistory} />}
          {bonusHistory && <Route path="/transaction/bonus_history" component={Bonushistory} />}
          {bonusHistory && <Route path="/transaction/penalty_history" component={PenaltyHistory} />}
          {withdrawlHistory && <Route path="/transaction/withdraw_history" component={Withdrawlhistory} />}
          <Route path="/transaction/withdraw" component={SucWithdraw} />

          {/* Report Routes */}
          {bonusReport && <Route path="/Reports/bonusReport" component={BonusReport}/>}
          {penaltyReport && <Route path="/Reports/penaltyReport" component={PenaltyReport}/>}
          {withdrawalReport && <Route path="/Reports/withdrawalReport" component={WithdrawalReport}/>}
          {depositReport && <Route path="/Reports/depositReport" component={DepositReport}/>}

          {/* Basic UI & Misc */}
          <Route path="/basic-ui/buttons" component={Buttons} />
          <Route path="/basic-ui/dropdowns" component={Dropdowns} />
          <Route path="/basic-ui/typography" component={Typography} />
          <Route path="/form-Elements/basic-elements" component={BasicElements} />
          <Route path="/tables/basic-table" component={BasicTable} />
          <Route path="/icons/mdi" component={Mdi} />
          <Route path="/charts/chart-js" component={ChartJs} />
          <Route path="/user-pages/register-1" component={Register1} />
          <Route path="/error-pages/error-404" component={Error404} />
          <Route path="/error-pages/error-500" component={Error500} />
          <Route path="/view/:id" component={Views} />
          {pages && <Route path="/Pages" component={Pages} />}
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;